import React, { useState } from "react";

function Language({ onClose }) {
  const [language, setLanguage] = useState("English");

  const translatePage = (lang) => {
    const googleTranslateElement = document.querySelector(".goog-te-combo");
    if (googleTranslateElement) {
      const langCode = lang === "Bangla" ? "bn" : "en";
      googleTranslateElement.value = langCode;
      googleTranslateElement.dispatchEvent(new Event("change"));
    }
    setLanguage(lang);
    onClose(); // ✅ Close modal
  };

  return (
    <>
      {/* ✅ Overlay click closes */}
      <div
        className="v-overlay v-overlay--active theme--dark"
        style={{
          zIndex: 201,
        }}
        onClick={onClose}
      >
        <div
          className="v-overlay__scrim"
          style={{
            opacity: "0.46",
            backgroundColor: "rgb(33, 33, 33)",
            borderColor: "rgb(33, 33, 33)",
            height: "100vh",
            width: "100vw",
          }}
        />
      </div>

      <div
        role="document"
        className="v-dialog__content v-dialog__content--active"
        style={{ zIndex: 202 }}
        tabIndex={0}
      >
        <div
          className="v-dialog v-dialog--active v-dialog--persistent"
          style={{ transformOrigin: "center center", maxWidth: "450px" }}
        >
          <div className="dialog-card v-card v-sheet theme--dark">
            {/* Header */}
            <div className="row no-gutters justify-space-between dialog-header pt-3 px-3">
              <div className="col col-11">
                <label className="dialog-title pt-3 ma-0 text-capitalize d-block full-width">
                  Currency and Language
                </label>
              </div>
              {/* ✅ Close button */}
              <div className="col col-1">
                <button
                  type="button"
                  className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon login"
                  onClick={onClose}
                />
              </div>
            </div>

            <div className="row no-gutters px-3 py-3">
              <div className="col col-12">
                <hr className="dialog-divider v-divider theme--dark" />
              </div>
            </div>

            {/* Language options */}
            <div className="row d-block dialog-row no-gutters pa-3 pt-0">
              <div className="row no-gutters align-center justify-space-between px-3">
                <div className="col col-2">
                  <div
                    className="v-avatar language-button"
                    style={{ height: "35px", minWidth: "35px", width: "35px" }}
                  >
                    <img src="https://bigtaka2.com/static/image/country/BDT_new.svg" alt="BDT" />
                  </div>
                </div>
                <div className="text-center col col-2">
                  <label>৳ BDT</label>
                </div>

                <div className="col col-8">
                  <div className="full-width v-item-group theme--dark v-btn-toggle">
                    <div className="row no-gutters">
                      <div className="text-right col col-6 px-1">
                        <button
                          type="button"
                          onClick={() => translatePage("English")}
                          className={`full-width font-weight-bold v-btn v-btn--outlined theme--dark v-size--default ${
                            language === "English" ? "v-btn--active" : ""
                          }`}
                        >
                          <span className="v-btn__content">English</span>
                        </button>
                      </div>

                      <div className="text-right col col-6 px-1">
                        <button
                          type="button"
                          onClick={() => translatePage("Bangla")}
                          className={`full-width font-weight-bold v-btn v-btn--outlined theme--dark v-size--default ${
                            language === "Bangla" ? "v-btn--active" : ""
                          }`}
                        >
                          <span className="v-btn__content">Bengali</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-2 col col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Language;
